import React, { Component, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { useState } from 'react';
import { AuthContext } from "../../AuthContext";
import { useViewPort } from '../Hooks/useViewPort';
import "../gdacs_2.0.css";
import "../custom.scss";
import { UserNameData } from "../UserCredentials/UserNameData";

const NavUserMenu = (props) => {
    const authContext = useContext(AuthContext);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { width } = useViewPort();
    const breakpoint = 620;

    const handleLogout = () => {
        authContext.logout();
    }


    useEffect(() => {
        setIsAuthenticated(props.isAuthenticated);
    }, [props])

    return (
        <>
            {
                authContext.isLoggedIn &&
                <div >
                    <header id="gdacs_header_menu" className="container_page">
                        {width > breakpoint &&
                            <Navbar id="navbar-gdasc-header" className="nav_bar_user nav-report" collapseOnSelect expand="lg" bg="white" variant="light" >
                                <Container className="navbar-report">
                                    <UserNameData params={authContext.data} />
                                    {/*                                    <Navbar.Collapse className="nav_bar_user"  >*/}
                                    <Nav className="ml-auto nav-link-user">
                                        <Nav className="nav_bar_user d-flex justify-content-right">
                                            <Nav className="ml-auto" >
                                            </Nav>
                                            <NavDropdown id="dropdown-toggle-user" title="ACTIONS" >
                                                <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/Home' }} >
                                                    About GDACS Events
                                </NavDropdown.Item >
                                                <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/EditProfile' }} >
                                                    Edit Profile
                                </NavDropdown.Item >
                                                <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/ChangePwd' }} >
                                                    Change Password
                                </NavDropdown.Item>
                                            {/*                                                <NavDropdown.Item className="nav_bar_user " as={Link} to={{ pathname: '/ValidateNumber' }} params={authContext.data} >*/}
                                            <NavDropdown.Item className="nav_bar_user " as={Link} to={{ pathname: '/ValidateContainer' }} params={authContext.data} >
                                                    Validate
                                </NavDropdown.Item>
                                                <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/UserDelete' }} >
                                                    Unsubscribe
                                </NavDropdown.Item>
                                                <NavDropdown.Divider />
                                                <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/' }} onClick={handleLogout}>Logout</NavDropdown.Item>
                                            </NavDropdown>
                                            <Nav.Link className="nav_bar_user nav-link-user" href="/gdacsregister/" onClick={handleLogout}>
                                                LOGOUT
                                                </Nav.Link>
                                        </Nav>
                                    </Nav>
                                </Container>
                            </Navbar>
                        }
                        {width < breakpoint &&
                            <Navbar className="nav_bar_user navbar-default nav-report" collapseOnSelect expand="lg" bg="white" variant="light">
                                <Container>
                                    <Navbar.Toggle className="responsive-navbar-nav-user nav-link-user" >
                                        <span className="navbar-toggler-icon" style={{ color: '#6d9baf', fontSize: '16px' }}></span>&nbsp;
                            Actions
                    </Navbar.Toggle>
                                    <Navbar.Collapse id="responsive-navbar-nav">
                                        <Nav>
                                            <NavDropdown.Item className="nav_bar_user" as={Link} to={{ pathname: '/Home' }} >
                                                About Gdacs Events
                                </NavDropdown.Item >
                                            <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/EditProfile' }}>
                                                Edit Profile
                                </NavDropdown.Item >
                                            <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/ChangePwd' }}>
                                                Change Password
                                </NavDropdown.Item>
                                        {/*                                            <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/ValidateNumber' }} params={authContext.data} >*/}
                                        <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/ValidateContainer' }} params={authContext.data} >
                                                Validate
                                </NavDropdown.Item>
                                            <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/UserDelete' }}>
                                                Unsubscribe
                                </NavDropdown.Item>
                                            <NavDropdown.Item className="nav_bar_user nav-link-user" as={Link} to={{ pathname: '/' }} onClick={handleLogout}>Logout</NavDropdown.Item>
                                        </Nav>
                                    </Navbar.Collapse>
                                </Container>
                            </Navbar>
                        }
                    </header>
                </div>
            }
        </>
    );
}
export { NavUserMenu }